import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="container-x py-20 max-w-5xl">
      <span className="pill">Our mission</span>
      <h1 className="mt-6 text-4xl sm:text-5xl font-black tracking-tight">Why sonographer injuries matter.</h1>
      <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
        Sonographers carry the diagnostic backbone of modern medicine—yet they sustain some of the highest rates of work-related
        musculoskeletal injury of any healthcare profession. We built Sonote to make prevention the default, not an afterthought.
      </p>
      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {[
          { t: "Mission", d: "Eliminate preventable sonographer injuries through daily, data-driven wellness." },
          { t: "Vision", d: "A world where every clinician scans for an entire career without chronic pain." },
          { t: "Values", d: "Clinician-first design. Anonymized analytics. Research-grade rigor." },
        ].map((b) => (
          <div key={b.t} className="card-marketing" data-testid={`about-${b.t.toLowerCase()}`}>
            <h3 className="font-bold text-xl">{b.t}</h3>
            <p className="mt-3 text-zinc-600">{b.d}</p>
          </div>
        ))}
      </div>
      <div className="mt-20 flex justify-center">
        <Link to="/contact" className="btn-outline" data-testid="about-contact-btn">Talk to our team</Link>
      </div>
    </div>
  );
}
